
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thjonustusvaedi",
      function () {
        return require("private-next-pages/thjonustusvaedi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thjonustusvaedi"])
      });
    }
  